module.exports = __webpack_public_path__ + "static/media/identity-linvitation-package.865cbf1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-linvitation-package.jpg
// module id = 251
// module chunks = 0